
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Logo: React.FC = () => {
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();

  const handleImageError = () => {
    console.log("Logo image failed to load");
    setImageError(true);
  };

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    console.log("Logo clicked, navigating to home page");
    try {
      // Użyj navigate do przejścia na stronę główną
      navigate('/');
      window.scrollTo(0, 0);
    } catch (error) {
      console.error("Navigation error:", error);
      // Fallback, gdyby navigate nie zadziałało
      window.location.href = '/';
    }
  };

  return (
    <div className="logo-container flex items-center cursor-pointer" onClick={handleLogoClick}>
      {!imageError ? (
        <img 
          src="/lovable-uploads/9f5b13b6-e492-470b-b986-05f591dbdaf5.png" 
          alt="Czułe klispe logo" 
          className="h-12 md:h-16"
          onError={handleImageError}
        />
      ) : (
        <div className="h-12 md:h-16 flex items-center text-navy-900 font-serif text-xl md:text-2xl">
          czułe klispe
        </div>
      )}
    </div>
  );
};

export default Logo;
